<template>
  <div>
    <div class="margin-top-lg flex justify-between">
      <div class="flex justify-start">
        <div :span="3" class="padding-right-xs padding-left-xl">
          <el-select v-model="simplifyFeeReceiptInfo.objType" size="small" @change="_changeSimplifyFeeReceiptFeeTypeCd"
            :placeholder="$t('simplifyFeeReceipt.selectFeeType')">
            <el-option v-for="(item, index) in simplifyFeeReceiptInfo.objTypes" :key="index" :label="item.name"
              :value="item.statusCd"></el-option>
          </el-select>
        </div>
        <div :span="3" class="padding-right-xs padding-left-xl" v-if="simplifyFeeReceiptInfo.objType == '6666'">
          <el-select v-model="simplifyFeeReceiptInfo.carId" size="small" @change="changeSimplifyFeeReceiptCar"
            :placeholder="$t('simplifyFeeReceipt.selectCar')">
            <el-option v-for="(item, index) in simplifyFeeReceiptInfo.ownerCars" :key="index" :label="item.carNum"
              :value="item.carId"></el-option>
          </el-select>
        </div>
        <div :span="3" class="padding-right-xs padding-left-xl" v-else-if="simplifyFeeReceiptInfo.objType == '7777'">
          <el-select v-model="simplifyFeeReceiptInfo.contractId" size="small" @change="changeSimplifyFeeReceiptCar"
            :placeholder="$t('simplifyFeeReceipt.selectContract')">
            <el-option v-for="(item, index) in simplifyFeeReceiptInfo.ownerContracts" :key="index"
              :label="item.contractCode" :value="item.contractId"></el-option>
          </el-select>
        </div>
        <div :span="3" class="padding-right-xs padding-left-xl" v-if="simplifyFeeReceiptInfo.objType != '7777' && simplifyFeeReceiptInfo.objType != ''">
          <el-select v-model="simplifyFeeReceiptInfo.ownerFlag" size="small" @change="_queryFeeReceiptMethod">
            <el-option
              :label="$t('simplifyFeeReceipt.current') + (simplifyFeeReceiptInfo.objType == '6666' ? $t('simplifyFeeReceipt.car') : $t('simplifyFeeReceipt.room'))"
              value="F"></el-option>
            <el-option
              :label="$t('simplifyFeeReceipt.all') + (simplifyFeeReceiptInfo.objType == '6666' ? $t('simplifyFeeReceipt.car') : $t('simplifyFeeReceipt.room'))"
              value="T"></el-option>
          </el-select>
        </div>
        <div :span="3" class="padding-right-xs padding-left-xl">
          <el-date-picker v-model="simplifyFeeReceiptInfo.startDate" type="date" size="small"
            value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 135px;">
          </el-date-picker>
        </div>
        <div :span="3" class="padding-right-xs">
          <el-date-picker v-model="simplifyFeeReceiptInfo.endDate" type="date" size="small"
            value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 135px;">
          </el-date-picker>
        </div>
        <div :span="3" class="padding-right-xs padding-left-xl">
          <el-input v-model="simplifyFeeReceiptInfo.receiptCode" size="small"
            :placeholder="$t('simplifyFeeReceipt.receiptCode')"></el-input>
        </div>
        <div :span="2" class="padding-right-xs padding-left-xl">
          <el-button type="primary" size="small" @click="_queryFeeReceiptMethod">
            {{ $t('simplifyFeeReceipt.query') }}
          </el-button>
        </div>
      </div>
      <div :span="8" class="text-right padding-right-lg">
        <el-button type="primary" size="small" @click="_printFeeReceipt('OFF')">
          {{ $t('simplifyFeeReceipt.print') }}
        </el-button>
        <el-button type="primary" size="small" @click="_printFeeReceipt('ON')">
          {{ $t('simplifyFeeReceipt.mergePrint') }}
        </el-button>
      </div>
    </div>
    <div class="margin-top">
      <!-- 全部类型：按对象（房屋/每辆车/合同）分组显示 -->
      <div v-if="simplifyFeeReceiptInfo.objType === ''" class="receipt-grouped">
        <div class="group-toolbar">
          <label class="group-check">
            <input type="checkbox" :checked="_allSelected()" @change="_toggleAll($event.target.checked)" />
            <span>全选（已选 {{ simplifyFeeReceiptInfo.selectReceipts.length }}/{{ simplifyFeeReceiptInfo.feeReceipts.length }}）</span>
          </label>
        </div>
        <div v-if="!simplifyFeeReceiptInfo.feeReceipts.length" class="empty-tip">暂无收据</div>
        <div v-for="g in groupedReceipts" :key="g.key" class="receipt-group">
          <div class="group-header">
            <label class="group-check">
              <input type="checkbox" :checked="_groupAllSelected(g)" @change="_toggleGroup(g, $event.target.checked)" />
              <span><b>{{ g.typeLabel }}</b> · {{ g.objName || '-' }}</span>
            </label>
            <span class="group-count">{{ g.receipts.length }} 条</span>
          </div>
          <el-table :data="g.receipts" border size="mini" class="group-table">
            <el-table-column width="45" align="center">
              <template slot-scope="scope">
                <input type="checkbox" :checked="_isSelected(scope.row)" @change="_toggleRow(scope.row, $event.target.checked)" />
              </template>
            </el-table-column>
            <el-table-column prop="receiptCode" :label="$t('simplifyFeeReceipt.receiptCode')" align="center"></el-table-column>
            <el-table-column label="票据类型" align="center" width="85">
              <template slot-scope="scope">{{ _receiptTypeName(scope.row.receiptType) }}</template>
            </el-table-column>
            <el-table-column prop="feeName" :label="$t('simplifyFeeReceipt.feeItem')" align="center"></el-table-column>
            <el-table-column :label="$t('simplifyFeeReceipt.timePeriod')" align="center" width="220">
              <template slot-scope="scope">
                <span v-if="_isSameDay(scope.row.startTime, scope.row.endTime)">{{ _getMonthRange(scope.row.startTime) }}</span>
                <span v-else>{{ dateFormat(scope.row.startTime) }}~{{ dateFormat(scope.row.endTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="amount" :label="$t('simplifyFeeReceipt.totalAmount')" align="center">
              <template slot-scope="scope">{{ scope.row.amount }}{{ $t('simplifyFeeReceipt.yuan') }}</template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('simplifyFeeReceipt.payTime')" align="center"></el-table-column>
            <el-table-column prop="receiptId" :label="$t('simplifyFeeReceipt.receiptId')" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 单类型：平铺表格 -->
      <el-table v-else :data="simplifyFeeReceiptInfo.feeReceipts" @selection-change="handleSelectionChange" border stripe>
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="receiptCode" :label="$t('simplifyFeeReceipt.receiptCode')"
          align="center"></el-table-column>
        <el-table-column label="票据类型" align="center" width="85">
          <template slot-scope="scope">{{ _receiptTypeName(scope.row.receiptType) }}</template>
        </el-table-column>
        <el-table-column :label="$t('simplifyFeeReceipt.feeType')" align="center">
          <template slot-scope="scope">
            {{ _getFeeObjName(scope.row.objType) }}{{ $t('simplifyFeeReceipt.fee') }}
          </template>
        </el-table-column>
        <el-table-column prop="objName" :label="_getFeeObjName(simplifyFeeReceiptInfo.objType)"
          align="center"></el-table-column>
        <el-table-column prop="payObjName" :label="$t('simplifyFeeReceipt.owner')" align="center"></el-table-column>
        <el-table-column prop="feeName" :label="$t('simplifyFeeReceipt.feeItem')" align="center"></el-table-column>
        <el-table-column :label="$t('simplifyFeeReceipt.timePeriod')" align="center" width="220">
          <template slot-scope="scope">
            <span v-if="_isSameDay(scope.row.startTime, scope.row.endTime)">
              {{ _getMonthRange(scope.row.startTime) }}
            </span>
            <span v-else>
              {{ dateFormat(scope.row.startTime) }}~{{ dateFormat(scope.row.endTime) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('simplifyFeeReceipt.totalAmount')" align="center">
          <template slot-scope="scope">
            {{ scope.row.amount }}{{ $t('simplifyFeeReceipt.yuan') }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('simplifyFeeReceipt.payTime')" align="center"></el-table-column>
        <el-table-column prop="receiptId" :label="$t('simplifyFeeReceipt.receiptId')" align="center"></el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getCommunityId, getDict } from '@/api/community/communityApi'
import { queryFeeReceipt, listFeePrintPage } from '@/api/fee/simplifyFeeReceiptApi'
import { queryOwnerCars } from '@/api/room/ownerCarsApi'
import { queryContract } from '@/api/contract/contractChangeDetailApi'
import { dateFormat } from '@/utils/dateUtil'

export default {
  name: 'SimplifyFeeReceipt',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 50,
      simplifyFeeReceiptInfo: {
        feeReceipts: [],
        objType: '3333',
        objId: '',
        payObjId: '',
        roomId: '',
        carId: '',
        receiptCode: '',
        total: '',
        records: '',
        ownerId: '',
        objTypes: [],
        ownerCars: [],
        ownerContracts: [],
        selectReceipts: [],
        ownerFlag: 'F',
        contractId: '',
        quan: false,
        printUrl: '/#/pages/property/printPayFee',
        startDate: '',
        endDate: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  watch: {
    'simplifyFeeReceiptInfo.selectReceipts': {
      handler(newVal) {
        this.simplifyFeeReceiptInfo.quan = newVal.length === this.simplifyFeeReceiptInfo.feeReceipts.length
      },
      deep: true
    }
  },
  computed: {
    // 全部类型下按对象（房屋/每辆车/合同）分组
    groupedReceipts() {
      const typeOrder = { '3333': 0, '6666': 1, '7777': 2 }
      const map = {}
      const order = []
      this.simplifyFeeReceiptInfo.feeReceipts.forEach(r => {
        const key = (r.objType || '') + '||' + (r.objId || r.objName || '')
        if (!map[key]) {
          map[key] = { key, objType: r.objType, objId: r.objId, objName: r.objName, receipts: [] }
          order.push(key)
        }
        map[key].receipts.push(r)
      })
      return order.map(k => {
        const g = map[k]
        return {
          key: g.key,
          objType: g.objType,
          objId: g.objId,
          objName: g.objName,
          receipts: g.receipts,
          typeLabel: this._getFeeObjName(g.objType)
        }
      }).sort((a, b) => {
        const oa = typeOrder[a.objType] === undefined ? 9 : typeOrder[a.objType]
        const ob = typeOrder[b.objType] === undefined ? 9 : typeOrder[b.objType]
        return oa - ob
      })
    }
  },
  created() {
  },
  methods: {
    handleSwitch(param) {
      // 必须有房屋或车辆
      if (param.roomId === '' && param.carId === '') return

      this.clearSimplifyFeeReceiptInfo()
      this._loadDictData()

      this._listFeePrintPages()
      Object.assign(this.simplifyFeeReceiptInfo, param)

      // 默认最近3天
      const today = new Date()
      const threeDaysAgo = new Date(today.getTime() - 2 * 24 * 60 * 60 * 1000)
      this.simplifyFeeReceiptInfo.startDate = this._formatDate(threeDaysAgo)
      this.simplifyFeeReceiptInfo.endDate = this._formatDate(today)

      // 默认「全部类型」：只查当前对象（房屋/车辆）的收据；只有在没有指定房屋/车辆时，才按业主查询
      // 这样 carCreateFee / roomCreateFee 不会混入该业主其他房屋/车辆的数据
      this.simplifyFeeReceiptInfo.objType = ''
      this.simplifyFeeReceiptInfo.payObjId = (param.roomId || param.carId) ? '' : param.ownerId

      // 车辆入口时预设默认车辆
      if (param.carId && !param.roomId) {
        this.simplifyFeeReceiptInfo.carId = param.carId
      }

      this._listSimplifyFeeReceipt(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this._listSimplifyFeeReceipt(val, this.DEFAULT_ROWS)
    },
    async _loadDictData() {
      try {
        const data = await getDict('fee_receipt', 'obj_type')
        // 首项为「全部类型」：objType 传空时后端不过滤 obj_type，配合 payObjId 即可查出该业主全部房屋+车辆+合同收据
        this.simplifyFeeReceiptInfo.objTypes = [
          { name: this.$t('simplifyFeeReceipt.allType'), statusCd: '' },
          ...data
        ]
      } catch (error) {
        console.error('Failed to load dict data:', error)
      }
    },
    async _listSimplifyFeeReceipt(page, rows) {
      this.simplifyFeeReceiptInfo.selectReceipts = []
      this.simplifyFeeReceiptInfo.quan = false
      let objId = ''
      if (this.simplifyFeeReceiptInfo.objType === '3333') {
        objId = this.simplifyFeeReceiptInfo.roomId
      } else if (this.simplifyFeeReceiptInfo.objType === '6666') {
        objId = this.simplifyFeeReceiptInfo.carId
      } else {
        objId = this.simplifyFeeReceiptInfo.contractId
      }

      const params = {
        page,
        row: rows,
        objType: this.simplifyFeeReceiptInfo.objType,
        objId,
        receiptCode: this.simplifyFeeReceiptInfo.receiptCode,
        communityId: getCommunityId(),
        orderBy: 'start_time',
        qstartTime: this.simplifyFeeReceiptInfo.startDate || '',
        qendTime: this.simplifyFeeReceiptInfo.endDate || ''
      }

      // 是否需要合并车辆收据：无业主 + 有房屋 + 没有指定车辆 + 非纯车辆/合同类型
      const needMergeCarReceipt = !this.simplifyFeeReceiptInfo.payObjId
        && this.simplifyFeeReceiptInfo.roomId
        && !this.simplifyFeeReceiptInfo.carId
        && this.simplifyFeeReceiptInfo.objType !== '6666'
        && this.simplifyFeeReceiptInfo.objType !== '7777'

      if (this.simplifyFeeReceiptInfo.ownerFlag === 'T' || this.simplifyFeeReceiptInfo.objType === '') {
        // 「全部类型」或「全部房屋/车辆」：按业主查询，不限定具体对象
        params.objId = ''
        params.payObjId = this.simplifyFeeReceiptInfo.payObjId
        // 没有业主时无法按业主查询"全部"（payObjId为空会导致返回整个小区收据）
        // 此时回退为按当前对象过滤
        if (!this.simplifyFeeReceiptInfo.payObjId) {
          // 优先按车辆、再按房屋回退，避免 carCreateFee 误用 roomId 显示整个房间收据
          params.objId = this.simplifyFeeReceiptInfo.carId || this.simplifyFeeReceiptInfo.roomId || ''
          delete params.payObjId
        }
      }

      try {
        let list = []
        if (needMergeCarReceipt) {
          // 无业主 + 有房屋 + 全部/全部房屋：需同时查询房屋收据和名下车辆收据
          const roomRes = await queryFeeReceipt(params)
          if (roomRes.data && roomRes.data.length > 0) {
            list.push(...roomRes.data)
          }

          // 查询房屋绑定的车辆，再逐车查询收据
          try {
            const carRes = await queryOwnerCars({
              page: 1,
              row: 50,
              roomId: this.simplifyFeeReceiptInfo.roomId,
              communityId: getCommunityId()
            })
            const cars = carRes.data || []
            for (const car of cars) {
              const carParams = {
                page: 1,
                row: 200,
                objType: '',
                objId: car.carId,
                receiptCode: this.simplifyFeeReceiptInfo.receiptCode,
                communityId: getCommunityId(),
                orderBy: 'start_time',
                qstartTime: this.simplifyFeeReceiptInfo.startDate || '',
                qendTime: this.simplifyFeeReceiptInfo.endDate || ''
              }
              const carReceiptRes = await queryFeeReceipt(carParams)
              if (carReceiptRes.data && carReceiptRes.data.length > 0) {
                list.push(...carReceiptRes.data)
              }
            }
          } catch (carErr) {
            console.error('加载车辆收据失败', carErr)
          }
        } else {
          const res = await queryFeeReceipt(params)
          list = res.data || []
          this.simplifyFeeReceiptInfo.total = res.total
          this.simplifyFeeReceiptInfo.records = res.records
        }

        // 去重（同一收据可能从不同路径查到）+ 只显示正常收据(statusCd='0')
        // 排除预收票据(1001)、已作废(2002)及其它非正常状态
        const seen = new Set()
        list = list.filter(r => {
          if (r.statusCd !== '0') return false
          if (seen.has(r.receiptId)) return false
          seen.add(r.receiptId)
          return true
        })

        list.sort((a, b) => {
          const ta = new Date(a.startTime || 0).getTime()
          const tb = new Date(b.startTime || 0).getTime()
          return ta - tb
        })
        this.simplifyFeeReceiptInfo.feeReceipts = list
        // 总数按过滤后的实际数量展示（排除作废/预收等非正常收据）
        this.simplifyFeeReceiptInfo.total = list.length
        this.total = list.length
      } catch (error) {
        console.error('Request failed:', error)
      }
    },
    _queryFeeReceiptMethod() {
      this._listSimplifyFeeReceipt(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _printFeeReceipt(merge) {
      if (this.simplifyFeeReceiptInfo.selectReceipts.length < 1) {
        this.$message.warning(this.$t('simplifyFeeReceipt.selectReceipt'))
        return
      }
      const receiptids = this.simplifyFeeReceiptInfo.selectReceipts.join(',')
      const url = `${this.simplifyFeeReceiptInfo.printUrl}?receiptIds=${receiptids}&apply=N&merge=${merge}`
      console.log('===== 打开打印窗口 URL: ' + url + ' =====')
      window.open(url)
    },
    _printApplyFeeReceipt() {
      if (this.simplifyFeeReceiptInfo.selectReceipts.length < 1) {
        this.$message.warning(this.$t('simplifyFeeReceipt.selectReceipt'))
        return
      }
      const receiptids = this.simplifyFeeReceiptInfo.selectReceipts.join(',')
      window.open(`/#/pages/property/printPayFee?receiptIds=${receiptids}&apply=Y`)
    },
    _printFeeSmallReceipt() {
      if (this.simplifyFeeReceiptInfo.selectReceipts.length < 1) {
        this.$message.warning(this.$t('simplifyFeeReceipt.selectReceipt'))
        return
      }
      const receiptids = this.simplifyFeeReceiptInfo.selectReceipts.join(',')
      window.open(`/#/pages/property/printSmallPayFee?receiptIds=${receiptids}`)
    },
    clearSimplifyFeeReceiptInfo() {
      this.simplifyFeeReceiptInfo = {
        feeReceipts: [],
        objType: '3333',
        objId: '',
        roomId: '',
        carId: '',
        receiptCode: '',
        total: '',
        records: '',
        ownerId: '',
        objTypes: [],
        ownerCars: [],
        ownerContracts: [],
        selectReceipts: [],
        ownerFlag: 'F',
        contractId: '',
        quan: false,
        printUrl: '/#/pages/property/printPayFee',
        startDate: '',
        endDate: ''
      }
    },
    async _changeSimplifyFeeReceiptFeeTypeCd(objType) {
      // 切换收费类型：车辆/合同需先加载下拉数据，「全部类型」无需加载；切换后统一刷新收据列表
      if (objType === '6666') {
        try {
          await this._listSimplifyFeeReceiptOwnerCar()
        } catch (error) {
          console.error(error)
        }
      } else if (objType === '7777') {
        try {
          await this._listSimplifyFeeReceiptOwnerContract()
        } catch (error) {
          console.error(error)
        }
      }
      this._queryFeeReceiptMethod()
    },
    changeSimplifyFeeReceiptCar() {
      this._changeSimplifyFeeReceiptFeeTypeCd(this.simplifyFeeReceiptInfo.objType)
    },
    async _listSimplifyFeeReceiptOwnerCar() {
      try {
        const params = {
          page: 1,
          row: 50,
          carTypeCd: '1001',
          communityId: getCommunityId()
        }
        // 优先按业主查询，无业主时按房屋查询，再没有按carId（纯车牌）
        if (this.simplifyFeeReceiptInfo.ownerId) {
          params.ownerId = this.simplifyFeeReceiptInfo.ownerId
        } else if (this.simplifyFeeReceiptInfo.roomId) {
          params.roomId = this.simplifyFeeReceiptInfo.roomId
        } else if (this.simplifyFeeReceiptInfo.carId) {
          params.carId = this.simplifyFeeReceiptInfo.carId
        }
        const res = await queryOwnerCars(params)
        this.simplifyFeeReceiptInfo.ownerCars = res.data
        if (res.data.length > 0) {
          this.simplifyFeeReceiptInfo.carId = res.data[0].carId
          return res.data
        }
        throw new Error(this.$t('simplifyFeeReceipt.noCar'))
      } catch (error) {
        console.error('Request failed:', error)
        throw error
      }
    },
    async _listSimplifyFeeReceiptOwnerContract() {
      try {
        const res = await queryContract({
          page: 1,
          row: 50,
          objId: this.simplifyFeeReceiptInfo.ownerId,
          communityId: getCommunityId()
        })
        this.simplifyFeeReceiptInfo.ownerContracts = res.data
        if (res.data.length > 0) {
          this.simplifyFeeReceiptInfo.contractId = res.data[0].contractId
          return res.data
        }
        throw new Error(this.$t('simplifyFeeReceipt.noContract'))
      } catch (error) {
        console.error('Request failed:', error)
        throw error
      }
    },
    checkAllReceipt(e) {
      const checkObj = document.querySelectorAll('.checReceiptItem')
      if (e.target.checked) {
        checkObj.forEach(item => {
          if (!item.checked) {
            this.simplifyFeeReceiptInfo.selectReceipts.push(item.value)
          }
        })
      } else {
        this.simplifyFeeReceiptInfo.selectReceipts = []
      }
    },
    _getFeeObjName(feeTypeCd) {
      if (feeTypeCd === '3333') {
        return this.$t('simplifyFeeReceipt.room')
      } else if (feeTypeCd === '6666') {
        return this.$t('simplifyFeeReceipt.car')
      } else if (feeTypeCd === '7777') {
        return this.$t('simplifyFeeReceipt.contract')
      } else {
        return this.$t('simplifyFeeReceipt.allType')
      }
    },
    // 票据类型显示
    _receiptTypeName(type) {
      if (type === 'hand') return '手写收据'
      if (type === 'invoice') return '发票'
      return '机打收据'
    },
    async _listFeePrintPages() {
      try {
        const res = await listFeePrintPage({
          page: 1,
          row: 1,
          state: 'T',
          communityId: getCommunityId()
        })
        const feePrintPages = res.data
        console.log('===== 打印模板配置: data=' + JSON.stringify(feePrintPages) + ', default=' + this.simplifyFeeReceiptInfo.printUrl + ' =====')
        if (feePrintPages && feePrintPages.length > 0) {
          this.simplifyFeeReceiptInfo.printUrl = feePrintPages[0].url
          console.log('===== 使用数据库模板URL: ' + this.simplifyFeeReceiptInfo.printUrl + ' =====')
        }
      } catch (error) {
        console.error('Request failed:', error)
      }
    },
    open(params) {
      this.handleSwitch(params)
    },
    dateFormat(date) {
      return dateFormat(date)
    },
    _isSameDay(start, end) {
      if (!start || !end) return false
      return dateFormat(start) === dateFormat(end)
    },
    _formatDate(date) {
      if (!date) return ''
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    _getMonthRange(date) {
      if (!date) return ''
      const d = new Date(date)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const e = this.dateFormat(date)
      return `${y}-${m}-01~${e}`
    },
    handleSelectionChange(val) {
      this.simplifyFeeReceiptInfo.selectReceipts = val.map(item => item.receiptId)
    },
    // ===== 全部类型-分组勾选 =====
    _isSelected(row) {
      return this.simplifyFeeReceiptInfo.selectReceipts.indexOf(row.receiptId) > -1
    },
    _allSelected() {
      const list = this.simplifyFeeReceiptInfo.feeReceipts
      return list.length > 0 && list.every(r => this._isSelected(r))
    },
    _groupAllSelected(group) {
      return group.receipts.length > 0 && group.receipts.every(r => this._isSelected(r))
    },
    _toggleRow(row, checked) {
      const arr = this.simplifyFeeReceiptInfo.selectReceipts.slice()
      const i = arr.indexOf(row.receiptId)
      if (checked && i === -1) arr.push(row.receiptId)
      if (!checked && i > -1) arr.splice(i, 1)
      this.simplifyFeeReceiptInfo.selectReceipts = arr
    },
    _toggleGroup(group, checked) {
      const arr = this.simplifyFeeReceiptInfo.selectReceipts.slice()
      group.receipts.forEach(r => {
        const i = arr.indexOf(r.receiptId)
        if (checked && i === -1) arr.push(r.receiptId)
        if (!checked && i > -1) arr.splice(i, 1)
      })
      this.simplifyFeeReceiptInfo.selectReceipts = arr
    },
    _toggleAll(checked) {
      if (checked) {
        this.simplifyFeeReceiptInfo.selectReceipts = this.simplifyFeeReceiptInfo.feeReceipts.map(r => r.receiptId)
      } else {
        this.simplifyFeeReceiptInfo.selectReceipts = []
      }
    }
  }
}
</script>

<style scoped>
.margin-top-lg {
  margin-top: 20px;
}

.padding-right-xs {
  padding-right: 5px;
}

.padding-left-xl {
  padding-left: 20px;
}

.text-right {
  text-align: right;
}

.padding-right-lg {
  padding-right: 20px;
}

/* 全部类型-分组显示 */
.receipt-grouped .group-toolbar {
  margin-bottom: 12px;
  padding: 8px 10px;
  background: #f5f7fa;
  border-radius: 4px;
}
.receipt-grouped .empty-tip {
  text-align: center;
  color: #909399;
  padding: 30px 0;
}
.receipt-group {
  margin-bottom: 18px;
}
.receipt-group .group-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  background: #ecf5ff;
  border-left: 3px solid #409eff;
  margin-bottom: 6px;
  font-size: 13px;
}
.receipt-group .group-count {
  color: #909399;
  font-size: 12px;
}
.group-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
}
.group-check input[type="checkbox"] {
  cursor: pointer;
}
</style>